import { PHONES } from "@/data";

export const Footer = () => (
  <footer className="border-t border-white/10 px-5 pt-16 pb-28 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <div className="font-serif italic text-[22vw] leading-none gold-text sm:text-[14rem]">RS</div>
      <div className="mt-8 flex flex-col gap-4 text-sm text-zinc-400 sm:flex-row sm:justify-between">
        <span>Rejane Simões · Beauty Salon — Cabeleireiro e Estética</span>
        <span className="flex gap-6">
          {PHONES.map((p) => (
            <a key={p.id} data-testid={`footer-phone-${p.id}`} href={p.tel} className="hover:text-[#f3e5ab] transition-colors">{p.label}</a>
          ))}
        </span>
        <span>© {new Date().getFullYear()} RS Beauty Salon</span>
      </div>
    </div>
  </footer>
);
